import { getDescendantsText } from '@ps/bridge/qc/node/utils'
import { getSceneNodeByUuid } from '@ps/bridge/qc/base'
import _ from 'lodash'
import gameIframe from '../../bridge/iframe/iframe'
import { hasPermission } from '@ps/plugins/permission-manager/manager'
import keys from '@ps/permission/keys'
import * as languageScript from '@ps/bridge/qc/scripts/language'
import * as langScript from '@ps/bridge/qc/scripts/language'
import i18n from 'i18n'
import store from '@ps/store'
import { hasSelfDevPermission } from '@ps/permission/workbench'

const removeUnnecessaryAttrs = (obj: i18n.Text) => {
  if (!obj) return
  delete obj.stage
  delete obj.resource
  delete obj.group
}
const removeUnnecessaryStyle = (obj: i18n.Text) => {
  if (!obj || !obj.style) return
  const style = obj.style
  if (!hasPermission(keys.styleDeleteLine)) {
    delete style.enableDeleteline
    delete style.deletelineColor
    delete style.deletelineWidth
    delete style.deletelineSpacing
  }
  if (!hasPermission(keys.styleUnderline)) {
    delete style.enableUnderline
    delete style.underlineColor
    delete style.underlineWidth
    delete style.underlineSpacing
  }
  if (!hasPermission(keys.styleLineHeight)) {
    delete style.lineHeight
    delete style.lineSpacing
  }
  if (!hasPermission(keys.styleLetterSpacing)) {
    delete style.letterSpacing
  }
}

/**
 * 从 playable 的节点树中获取到 languages.json 中的语言配置
 * @returns {{}}
 */
export function getLanguagesFromGamePlay(): i18n.Languages {
  const languages: i18n.Languages = {}
  const textNodes = getDescendantsText(gameIframe.gamePlay)
  // 从节点中获取多语言信息
  textNodes.forEach((node) => {
    const psLang = langScript.getScript(node)
    const scene = getSceneNodeByUuid(node.uuid)
    // 场景名字使用 uniqueName 而不是 name
    const sceneName = scene ? scene.uniqueName : ''
    const langConfig = languageScript.getScript(node)
    if (!langConfig) {
      console.error('该文本节点没有多语言脚本')
      return
    }
    // 自研协同项目兜底修复文本的langKey丢失问题
    if (hasSelfDevPermission()) {
      if (!langConfig.langKey) {
        langConfig.langKey = node.uuid
      }
    }
    // 使用 langKey 作为配置的 key
    const prefix = langConfig.langKey
    if (prefix && psLang) {
      for (const i in psLang.langConfig) {
        // @ts-ignore
        if (typeof languages[i] === 'undefined') languages[i] = {}
        const currentConfig = _.cloneDeep(psLang.langConfig[i])
        const name = node.name

        const pdef = currentConfig['pdef']
        const ldef = currentConfig['ldef']
        if (pdef) {
          languages[i][prefix + '_V'] = {
            style: pdef.style as i18n.Style,
            value: pdef.value,
            name,
            // scene 是为了告知该文本节点属于哪个场景，后端不需要这些数据，但是pt前端需要
            scene: sceneName,
          }
          languages[i][prefix + '_H'] = {
            style: ldef.style as i18n.Style,
            value: ldef.value,
            name,
            scene: sceneName,
          }
        } else {
          // 兼容旧项目数据
          // @ts-ignore
          languages[i][prefix + '_V'] = {
            ...currentConfig,
            name,
            scene: sceneName,
          }
          // @ts-ignore
          languages[i][prefix + '_H'] = {
            ...currentConfig,
            name,
            scene: sceneName,
          }
        }
        // 移除多余属性
        removeUnnecessaryAttrs(languages[i][prefix + '_V'])
        removeUnnecessaryAttrs(languages[i][prefix + '_H'])
        // 移除多余的样式
        removeUnnecessaryStyle(languages[i][prefix + '_V'])
        removeUnnecessaryStyle(languages[i][prefix + '_H'])
      }
    } else {
      console.error('该文本节点多语言脚本没有 langKey')
    }
  })
  return languages
}

/**
 * 切换语言，读取文本节点语言脚本信息并赋值到文本节点上
 * @param lang
 */
export const switchLanguage = (lang: string): void => {
  const adapterResolution = store.state.workspace.game.device.adapterResolution
  languageScript.refreshTextLanguage(lang, adapterResolution)
}

/**
 * 切换横竖屏时更新语言
 * @param adapterResolution 横竖屏pdef ldef
 */
export const updateLanguageByDevice = (adapterResolution: string): void => {
  const lang = store.state.workspace.language.currentLanguage
  languageScript.refreshTextLanguage(lang, adapterResolution)
}

export const getLanguageFromLanguagesRes = ({
  lang,
  textConfigItem,
}: {
  lang: string
  textConfigItem: i18n.TextConfigItem
}) => {
  // 有 uuid 直接从节点上获取这些信息，不需要从languagesRes中获取
  if (textConfigItem.uuid) return
  const gamePlay = gameIframe.gamePlay
  const languagesRes = gameIframe.iframe.languagesMgr.getRes()
  // 补充那些没有关联节点的语言信息
  const config =
    _.get(languagesRes, `languages.${lang}.${textConfigItem.key}`) ||
    _.get(
      languagesRes,
      `languages.${languagesRes.fallbackLocale}.${textConfigItem.key}`,
    )
  const config_V =
    _.get(languagesRes, `languages.${lang}.${textConfigItem.key_V}`) || config
  const config_H =
    _.get(languagesRes, `languages.${lang}.${textConfigItem.key_H}`) || config

  if (!config && !config_V && !config_H) {
    console.error(
      `找不到$${textConfigItem.key}对应的语言配置信息`,
      textConfigItem,
    )
  }
  return {
    key_V: config_V,
    key_H: config_H,
  }
}
